import Backbone from "backbone";
import _ from "underscore";

export const BaseCollection = _.extend(
  {
    add(object) {
      // Prevent duplicates - only add if no object with same id exists
      if (!this.some((obj) => obj.id === object.id)) {
        this.push(object);
      }
    },

    remove(id) {
      const index = this.findIndex((obj) => obj.id === id);
      if (index !== -1) {
        this.splice(index, 1);
      }
    },

    isEmpty() {
      return this.length === 0;
    },

    sortBy(field) {
      this.sort((a, b) => {
        const aVal = a.get(field);
        const bVal = b.get(field);

        // If both have field, sort by it
        if (aVal !== undefined && bVal !== undefined) {
          return aVal - bVal;
        }

        // Fall back to updatedAt
        const aDate = a.updatedAt || a.createdAt || new Date(0);
        const bDate = b.updatedAt || b.createdAt || new Date(0);
        return aDate - bDate;
      });
    },
  },
  Backbone.Events,
);

export default BaseCollection;
